// extracted by mini-css-extract-plugin
export default {"-large":"media-section-module__-large--vAfM3","aiImageButton":"media-section-module__aiImageButton--AlCTl"};